(() => {
  if (window.tyvokFallMakerLoaded) return;
  window.tyvokFallMakerLoaded = true;
  const start = Date.parse('2026-09-14T00:00:00-04:00');
  const end = Date.parse('2026-09-27T23:59:00-04:00');
  const active = () => Date.now() >= start && Date.now() < end;
  const money = cents => new Intl.NumberFormat('en-US',{style:'currency',currency:'USD',maximumFractionDigits:cents % 100 ? 2 : 0}).format(cents/100);
  class FallCoupon extends HTMLElement {
    connectedCallback() {
      this.variants=JSON.parse(this.querySelector('[data-tfm-variants]')?.textContent || '[]');
      this.scope=this.closest('.shopify-section') || this.closest('[data-demo-product]') || this.parentElement;
      this.update=()=>{
        const id=this.scope.querySelector('[data-p2-variant-id]')?.value || this.scope.querySelector('form[action*="/cart/add"] [name="id"]')?.value || this.scope.querySelector('[data-demo-variant]')?.value || '';
        const v=this.variants.find(v=>String(v.id)===String(id));
        const valid=active() && (this.dataset.allowed || '').split(',').includes(String(id)) && v && v.available && v.price>=Number(this.dataset.amount);
        this.hidden=!valid;
        if(!valid) return;
        const key=`${id}:${v.price}`;
        if(this.key===key) return;
        this.key=key;
        this.querySelector('[data-tfm-price]').textContent=money(v.price-Number(this.dataset.amount));
        this.querySelector('[data-tfm-save]').textContent=`Save ${money(Number(this.dataset.amount))} on ${v.title.replace('-PRE','')}.`;
        this.querySelector('[data-tfm-status]').textContent='';

      };
      this.update();
      this.timer=setInterval(()=>{if(!document.hidden)this.update();},250);
    }
    disconnectedCallback(){clearInterval(this.timer);}
  }
  customElements.define('tyvok-fall-coupon',FallCoupon);
  const expire=()=>document.querySelectorAll('[data-tfm-banner]').forEach(el=>{el.hidden=!active();});
  expire();setInterval(expire,1000);
})();
